<template>
  <div class="bg-white shadow rounded-lg mb-4 p-4 sm:p-6 h-full">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-xl font-bold leading-none text-gray-900">{{ $t('dashboard.latest_interventions') }}</h3>
      <a href="/interventions?type=all" class="text-sm font-medium text-cyan-600 hover:bg-gray-100 rounded-lg inline-flex items-center p-2">
        {{ $t('global.view_all') }}
      </a>
    </div>
    <div class="flow-root">
      <ul role="list" class="divide-y divide-gray-200">
        <li class="py-3 sm:py-4" v-for="(item, key) in data">
          <div class="flex items-center space-x-4">
            <div class="flex-1 min-w-0">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ item.user_name }}
              </p>
              <p class="text-sm text-gray-500 truncate">
                {{ item.intervention_type }}
              </p>
            </div>
            <div class="inline-flex items-center text-base font-semibold text-gray-900">
              {{ $filters.fromNow(item.date) }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default{
  props: {
    data: Array
  }
}
</script>
